import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import IOSBadVersionBanner from '../../components/banners/IOSBadVersionBanner'

const mapStateToProps = state => ({
    isBadIOSVersion: state.getIn(['device', 'isBadIOSVersion']),
})

const IOSBadVersionBannerContainer = ({ isBadIOSVersion }) => {
    return isBadIOSVersion ? <IOSBadVersionBanner /> : null
}
export default compose(connect(mapStateToProps))(IOSBadVersionBannerContainer)
